<template>

    <transition name="fade-slide">

        <div class="keyboard-num fade-slide-bottom" v-if="visible">

            <span v-for="(item,index) in keydata" @click="seleted(item)" :status="item.key">{{item.value}}</span>

        </div>

    </transition>

</template>

<script>

    let key_data =[];

    for(var i=1;i<13;i++){

        if(i==10){
            key_data.push({value:'清空',key:i})
        }

        else if(i==11){
            key_data.push({value:0,key:i})
        }

        else if(i == 12){
            key_data.push({value:'回删',key:i})

        }

        else{
            key_data.push({value:i,key:i})
        }


    }

    // console.log('key_data',key_data);

    export default {
        name: "Key_Number",

        data(){
            return {

                visible:this.value,
                keydata:key_data,

            }
        },

        props:{

            value:{
                default:false
            }
        },

        watch:{
          value(boolean){
              this.visible = boolean;
          }
        },

        methods:{

            seleted(item){

                // console.log('item',item);
                this.$emit('on-result',item)
            }

        }
    }
</script>

<style lang="less">

    @import "../../styles/cssBlock.less";

    #app .keyboard-num{

        .fixedByCover();
        top: auto !important;
        bottom: 0px;
        z-index: 9010;
        pointer-events: auto;
        color: @fontColorA1;
        background-color:@themeReverseColor;
        @height:@150px;
        >span{
            display: inline-block;
            height: @height;
            line-height: @height;
            text-align: center;
            width: 33.33%;
            float: left;
            border: 1px solid @borderColorA2;
            border-top:none;
            border-left:none;

            font-size: @fontSizeA1;

            &[status='10'],
            &[status='12']{
                font-size: @fontSizeA2;
            }

            &:active{background-color: @bodyBgColor}
        }

    }

</style>
